import { type TPromoRelease as TApiPromoRelease } from '@core/api'

import { type TPromoRelease } from '@core/models'

import { convertCollection } from './convertCollection'

export const convertPromoRelease = (apiPromoRelease: TApiPromoRelease): TPromoRelease => {
    return {
        id: String(apiPromoRelease.id),
        slug: apiPromoRelease.slug,
        design: apiPromoRelease.design,
        status: apiPromoRelease.status,
        username: apiPromoRelease.username,
        ownerDisplayName: apiPromoRelease.owner_display_name,
        ownerUserId: apiPromoRelease.user_id,
        links: apiPromoRelease.links,
        datePublished: apiPromoRelease.date_published,
        dateCreated: apiPromoRelease.date_created,
        dateUpdated: apiPromoRelease.date_updated,
        collection: apiPromoRelease.collection
            ? convertCollection(apiPromoRelease.collection)
            : undefined,
        canMutateCollection: apiPromoRelease.can_mutate_collection,
        type: apiPromoRelease.type,
    }
}
